/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_payment_method = /** @type {(inputs: {}) => string} */ () => {
	return `Způsob platby`
};

const da_payment_method = /** @type {(inputs: {}) => string} */ () => {
	return `Betalingsmetode`
};

const de_payment_method = /** @type {(inputs: {}) => string} */ () => {
	return `Zahlungsart`
};

const en_payment_method = /** @type {(inputs: {}) => string} */ () => {
	return `Payment method`
};

const es_payment_method = /** @type {(inputs: {}) => string} */ () => {
	return `Método de pago`
};

const fr_payment_method = /** @type {(inputs: {}) => string} */ () => {
	return `Mode de paiement`
};

const hu_payment_method = /** @type {(inputs: {}) => string} */ () => {
	return `Fizetési mód`
};

const it_payment_method = /** @type {(inputs: {}) => string} */ () => {
	return `Metodo di pagamento`
};

const nl_payment_method = /** @type {(inputs: {}) => string} */ () => {
	return `Betaalmethode`
};

const pl_payment_method = /** @type {(inputs: {}) => string} */ () => {
	return `Metoda płatności`
};

const pt_payment_method = /** @type {(inputs: {}) => string} */ () => {
	return `Método de pagamento`
};

const sv_payment_method = /** @type {(inputs: {}) => string} */ () => {
	return `Betalningsmetod`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const payment_method = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.payment_method(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("payment_method", locale)
	if (locale === "cs") return cs_payment_method(inputs)
	if (locale === "da") return da_payment_method(inputs)
	if (locale === "de") return de_payment_method(inputs)
	if (locale === "en") return en_payment_method(inputs)
	if (locale === "es") return es_payment_method(inputs)
	if (locale === "fr") return fr_payment_method(inputs)
	if (locale === "hu") return hu_payment_method(inputs)
	if (locale === "it") return it_payment_method(inputs)
	if (locale === "nl") return nl_payment_method(inputs)
	if (locale === "pl") return pl_payment_method(inputs)
	if (locale === "pt") return pt_payment_method(inputs)
	return sv_payment_method(inputs)
};